<template>
  <div class="text-select-input clearfix">
    <div v-show="show" class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <select class="form-control" ref="dropdown"
        :name="options.name" @change="validate()">
          <option v-for="(val, index) in options.existing"
            :key="index"
            :value="val.value"
            :checked="val.value === value">{{ val.label }}</option>
        </select>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
    <div class="loader" v-if="newAdded && !dismiss">
      <i class="fa fa-exclamation-triangle mr-2"></i>
      Save new {{ options.label }}, {{ value }}, in database?
      <i @click="saveNewVal()" class="fa fa-check text-success mx-3 interactive-cursor"></i>
      <i @click="dismiss=true" class="fa fa-times text-danger interactive-cursor"></i>
    </div>
    <div id="map" v-show="false"></div>
  </div>
</template>

<script>
  import Api from '@/vuex/api'
  import Choices from 'choices.js'
  import dom from '@/util/dom'
  import {
    validationClass,
    validationMessage
  } from '@/util/helpers'

  export default {
    name: 'AddressInput',
    props: {
      value: {
        type: String
      },
      options: {
        type: Object,
        default () {
          return {
            value: '',
            label: 'Text',
            name: 'text-select',
            existing: [],
            required: false
          }
        }
      }
    },
    data () {
      return {
        show: true,
        lat: -37.8098,
        lng: 144.9638,
        isDirty: false,
        isValid: false,
        currentResults: false,
        choices: false,
        saveNew: false,
        newAdded: false,
        dismiss: false,
        existingAddresses: [],
        uuidRegex: /^[0-9a-f]{8}-[0-9a-f]{4}-[1-4][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
        placesService: null,
        idMap: {},
        watcher: false
      }
    },
    computed: {
      invalidMessage () {
        return this.options.label + ' is required'
      },
      label () {
        return this.options.singleLabel
          ? this.options.singleLabel
          : this.options.label
      },
      validationClass,
      validationMessage
    },
    updated () {
      let data = this.choices.getValue()
      let val = data ? data.value : null
      if (val !== this.value) {
        // make sure value is in the existing objects
        let found = this.choices.currentState.choices.find(el => el.value === this.value)
        if (!found) {
          this.choices.setValue([{ value: this.value, label: this.value }])
        } else {
          this.choices.setValueByChoice(this.value)
        }
        this.validate()
      }
    },
    mounted () {
      let map = new google.maps.Map(document.getElementById('map'))
      this.placesService = new google.maps.places.PlacesService(map)
      if (this.options.show === false) this.show = false
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(position => {
          this.lat = position.coords.latitude
          this.lng = position.coords.longitude
        })
      }
      this.existingAddresses = this.options.existing || []
      let service = new google.maps.places.AutocompleteService()
      let $vm = this
      /* eslint-disable no-new */
      this.choices = new Choices(this.$refs.dropdown, {
        placeholderValue: 'Enter a ' + this.options.label,
        noResultsText: 'Press enter to add a new value',
        removeItemButton: true,
        fuseOptions: {
          maxPatternLength: 128,
          threshold: 0
        },
        noChoicesText: 'Enter an address',
        callbackOnInit: function () {
          this.containerInner.id = $vm.options.name
          if (!$vm.value) {
            let arr = this.store.getItemsFilteredByActive()
            if (arr.length > 0) {
              let value = arr.pop().value
              this.removeItemsByValue(value)
            }
          } else {
            this.setValueByChoice($vm.value)
            $vm.validate()
          }
        }
      })
      document.removeEventListener('click', this.choices._onClick)
      document.removeEventListener('keyup', this.choices._onKeyUp)
      document.removeEventListener('keydown', this.choices._onKeyDown)
      document.addEventListener('click', (e) => {
        if (e.target.className.includes('choices') && e.target.tagName !== 'BUTTON') {
          this.choices._onClick(e)
        }
      }, true)
      document.addEventListener('keydown', (e) => {
        if (document.activeElement.className.includes('choices')) {
          if (e.keyCode === 13) {
            this.choices._onKeyDown(e)
            this.isSearching = false
          } else if (e.target.className.includes('choices')) {
            this.isSearching = true
            this.choices._onKeyDown(e)
          }
        } else {
          this.isSearching = false
        }
      }, true)
      document.addEventListener('keyup', (e) => {
        if (this.isSearching && document.activeElement.className.includes('choices')) {
          this.choices._onKeyUp(e)
        }
      }, true)
      // add custom adding items behaviour
      this.$refs.dropdown.addEventListener('search', (event) => {
        let location = new google.maps.LatLng({lat: this.lat, lng: this.lng})
        service.getPlacePredictions({ input: event.detail.value, location, radius: 1000 }, function (predictions, status) {
          $vm.choices.input.removeEventListener('keydown', $vm.addSearchValue)
          if (status === 'OK') {
            $vm.addValues(predictions)
          } else {
            var searchOutput = Array.from($vm.choices.choiceList.children)
            var resultExist = false
            searchOutput.map((div) => {
              if (event.detail.value === div.innerHTML) {
                resultExist = true
              }
            })
            if (!resultExist) {
              $vm.currentResults = false
              $vm.choices.input.addEventListener('keydown', $vm.addSearchValue)
            }
          }
        })
      })
      // fix bug that causes dropdown to continually close until a key event is detected
      this.$refs.dropdown.addEventListener('showDropdown', (event) => {
        let prefill = this.choices.getValue()
        this.choices.input.value = prefill ? prefill.label : ''
        this.$nextTick(function () {
          var e = new window.Event('keydown', {
            'bubbles': true
          })
          e.key = 'a'
          e.keyCode = e.key.charCodeAt(0)
          e.which = e.keyCode
          e.altKey = false
          e.ctrlKey = true
          e.shiftKey = false
          e.metaKey = false
          this.choices.input.dispatchEvent(e)
          this.choices.input.focus()
        })
      })
    },
    methods: {
      async validate (val) {
        await this.$nextTick()
        let data = false
        if (!val) {
          data = this.choices.getValue()
          val = data ? data.value : null
          if (!val) {
            this.resetChoices()
          } else if (this.idMap[val]) {
            if (val.match(/[0-9]{4}/)) {
              val = val.replace('Australia', '')
              if (val.slice(-2) === ', ') val = val.slice(0, -2)
            } else {
              let postcode = await new Promise((resolve, reject) => {
                this.placesService.getDetails({
                  placeId: this.idMap[val]
                }, function (place, status) {
                  if (status === google.maps.places.PlacesServiceStatus.OK) {
                    let found = place.address_components.find((el) => {
                      return el.types.includes('postal_code')
                    })
                    if (found) resolve(found.long_name)
                  } else {
                    resolve(null)
                  }
                })
              })
              if (postcode) val = val.replace('Australia', postcode)
            }
          }
        }
        if (this.options.allowSave) {
          let found = this.existingAddresses.find(el => el.value === val)
          if (!found && val) {
            this.newAdded = true
            this.dismiss = false
          }
        }
        this.$emit('input', val)
        this.isDirty = true
        if (val) {
          this.isValid = true
        } else if (this.options.required) {
          this.isValid = false
          this.isDirty = true
        } else {
          this.isValid = true
        }
        let choicesInner = document.getElementById(this.options.name)
        if (this.isValid) {
          if (dom(choicesInner).hasClass('is-invalid')) {
            dom(choicesInner).removeClass('is-invalid')
          }
          if (!dom(choicesInner).hasClass('is-valid')) {
            dom(choicesInner).addClass('is-valid')
          }
        } else {
          if (dom(choicesInner).hasClass('is-valid')) {
            dom(choicesInner).removeClass('is-valid')
          }
          if (!dom(choicesInner).hasClass('is-invalid')) {
            dom(choicesInner).addClass('is-invalid')
          }
        }
      },
      async saveNewVal () {
        let instance = new Api()
        let newVal = await instance.saveNewVal({
          modelName: this.options.modelName,
          fieldName: this.options.fieldName,
          value: this.value
        })
        this.existingAddresses.push({
          value: newVal.uuid,
          label: newVal[this.options.fieldName]
        })
        this.resetChoices()
        await this.$nextTick()
        this.choices.setValueByChoice(newVal.uuid)
        this.validate()
        this.dismiss = true
      },
      addSearchValue (e) {
        // check if enter key is pressed, then add value
        let key = e.which || e.keyCode
        if (key === 13 && !this.currentResults) {
          this.choices.setValue([{ value: this.choices.currentValue, label: this.choices.currentValue }])
          this.validate(this.choices.currentValue)
        }
        this.choices.input.removeEventListener('keydown', this.addSearchValue)
      },
      resetChoices () {
        this.newAdded = false
        let valueFound = this.existingAddresses.find(el => el.value === this.value)
        if (valueFound || !this.isUuid(this.value)) {
          this.choices.setChoices(this.existingAddresses, 'value', 'label', true)
        } else {
          this.$emit('input', '')
          if (this.choices) {
            this.choices.clearInput()
            if (this.choices.containerInner.children[1].children[0]) {
              this.choices.containerInner.children[1].children[0].innerHTML = ''
            }
            this.choices.setChoices(this.existingAddresses, 'value', 'label', true)
          }
        }
      },
      addValues (results) {
        this.idMap = {}
        results.map((val, i) => {
          results[i] = { value: val.description, label: val.description }
          this.idMap[val.description] = val.place_id
        })
        if (this.choices) {
          this.choices.setChoices(results, 'value', 'label', true)
        }
      },
      runWatcher (val, name) {
        if (this.options.watchers.includes(name)) {
          if (!this.value || name === 'isCustom') this.watcher = true
          if (this.watcher) {
            if (val || val === false) {
              switch (name) {
                case 'companyName':
                  this.updateCompanyAddress(val)
                  break
                case 'ocManagerName':
                  this.getProperties(val)
                  break
                case 'sameAsPostal':
                  this.show = !val
                  break
              }
            } else {
              this.existingAddresses = []
              this.resetChoices()
              this.isDirty = false
            }
          }
          this.watcher = true
        }
      },
      async getProperties (val) {
        let instance = new Api()
        let properties = await instance.getManagerProperties(val)
        this.existingAddresses = []
        if (properties && properties.length) {
          properties.forEach(property => {
            this.existingAddresses.push({
              value: property.uuid,
              label: property.address
            })
          })
        }
        this.resetChoices()
      },
      async updateCompanyAddress (val) {
        let instance = new Api()
        let company = await instance.getCompany(val)
        if (company) {
          this.existingAddresses = [{
            value: company.postalAddress,
            label: company.postalAddress
          }]
          // Set the value to company address and validate
          this.choices.setChoices(this.existingAddresses, 'value', 'label', true)
          this.choices.setValueByChoice(company.postalAddress)
          this.validate(company.postalAddress)
        } else {
          // Reset the choices if no company is found
          this.resetChoices()
        }
      },
      isUuid (uuid) {
        if (!uuid) return false
        uuid = uuid.toLowerCase()
        return this.uuidRegex.test(uuid)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/AddressInput.vue